import { getEnv } from "@ace/env";
import { sessionStorageKeys } from "../constants";
import { KycData } from "@archax/web-lib";

export const getKyc = async (): Promise<KycData> => {
  const response = await fetch(`${getEnv("VITE_ACE_WEB_AUTH_SERVER")}/kyc`, {
    headers: {
      Authorization: `Bearer ${globalThis.sessionStorage.getItem(
        sessionStorageKeys.token,
      )}`,
    },
  });

  const res = await response.json();

  if (res.status === "ERROR") {
    const error = res.error[0].msg;
    throw new Error(error);
  }

  return res.data;
};
